import { API_URL } from "General/APIEndpoints";
import { action, observable, runInAction, makeObservable } from "mobx";
import { handleStoreState } from "Stores/RESTStore/CoreStore";
import { API } from "General/API";
import { CoreStore } from "Stores/RESTStore/CoreStore";

class WorkflowsStore extends CoreStore {
  data: API_AdminWorkflowDefinitionDetails[] = [];
  submitData: API_AdminWorkflowDefinitionParameters = null;
  projectId: string | number = null;
  workflowId: string | number = null;

  constructor() {
    super();

    makeObservable(this, {
      data: observable,
      submitData: observable,
      projectId: observable,
      workflowId: observable,
      clear: action.bound,
      setProjectId: action.bound,
      fetch: action.bound,
      fetchByWfId: action.bound,
      edit: action.bound,
      save: action.bound,
      activate: action.bound,
      deactivate: action.bound,
    });
  }

  clear() {
    this.data = [];
    this.submitData = null;
    this.projectId = null;
  }

  url(id?: string | number) {
    return id
      ? API_URL.ADMIN_WORKFLOWS.getWorkflowDefinitionById(this.projectId, id)
      : API_URL.ADMIN_WORKFLOWS.getWorkflowDefinitions_1(this.projectId);
  }

  @handleStoreState()
  async fetch(id?: string) {
    if (id) {
      this.setProjectId(id);
    }
    try {
      const response: API_AdminWorkflowDefinitionDetails[] = await API.getData(this.url());
      if (response) {
        runInAction(() => {
          this.data = response;
        });
      }
    } catch (err) {
      throw err;
    }
  }

  @handleStoreState()
  async fetchByWfId(id: string | number) {
    try {
      const response: API_AdminWorkflowDefinitionParameters = await API.getData(this.url(id));
      if (response) {
        runInAction(() => {
          this.submitData = response;
        });
      }
    } catch (err) {
      throw err;
    }
  }

  @handleStoreState()
  async edit(formData: API_AdminWorkflowDefinitionParameters) {
    try {
      await API.editData(API_URL.ADMIN_WORKFLOWS.updateWorkflowDefinition(this.projectId, formData.id), formData);
    } catch (error) {
      throw error;
    }
  }

  @handleStoreState()
  async save(formData: API_AdminWorkflowDefinitionParameters) {
    try {
      await API.newData(API_URL.ADMIN_WORKFLOWS.createWorkflowDefinition(this.projectId), formData);
    } catch (error) {
      throw error;
    }
  }

  @handleStoreState()
  async activate(id: number | string) {
    try {
      await API.newData(API_URL.ADMIN_WORKFLOWS.activateWorkflowDefinition(this.projectId, id), {});
      this.fetch();
    } catch (error) {
      throw error;
    }
  }

  @handleStoreState()
  async deactivate(id: number | string) {
    try {
      await API.deleteData(API_URL.ADMIN_WORKFLOWS.deactivateWorkflowDefinition(this.projectId, id));
      this.fetch();
    } catch (error) {
      throw error;
    }
  }

  setProjectId(id: string | number) {
    this.projectId = id;
  }
}

export const workflowsStore = new WorkflowsStore();
